import { styled } from 'styled-components';
import { screen, typography } from '@/styles/helpers';

export const ScResultModal = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  max-width: 480px;
  margin-inline: auto;
  padding: 32px 32px 20px;
  border-radius: 24px;
  background-color: ${({ theme }) => theme.grayDarkColor};
  overflow: hidden;

  @media (${screen.md}) {
    padding: 32px;
  }

  & .confetti {
    position: absolute;
    top: -67px;
    left: 0;
    width: 100%;
    height: auto;
    pointer-events: none;

    @media (${screen.md}) {
      top: -89px;
    }
  }

  & .content,
  & .actions {
    position: relative;
  }

  & .content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  & .status-icon {
    margin-inline: auto;
  }

  & .texts {
    display: flex;
    flex-direction: column;
    gap: 2px;
    text-align: center;
  }

  & .title {
    color: ${({ theme }) => theme.whiteColor};
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
  }

  & .subtitle {
    color: ${({ theme }) => theme.whiteColor};
    ${typography.body1regular}
  }

  & .amount-box {
    text-align: center;
  }

  & .amount {
    color: ${({ theme }) => theme.greenColor};
    font-size: 28px;
    font-weight: 700;
    line-height: 32px;
  }

  & .amount-note {
    color: ${({ theme }) => theme.greenColor};
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
  }

  & .product {
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 8px 16px;
    border-radius: 16px;
    background-color: ${({ theme }) => theme.blackColor};

    @media (${screen.md}) {
      gap: 16px;
      padding: 16px;
    }
  }

  & .product-image {
    flex-shrink: 0;
    width: 56px;
    height: 56px;

    @media (${screen.md}) {
      width: 64px;
      height: 64px;
    }
  }

  & .product-title {
    color: ${({ theme }) => theme.secondaryColor};
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;

    @media (${screen.md}) {
      font-size: 20px;
    }
  }

  & .product-note {
    color: ${({ theme }) => theme.whiteColor};
    ${typography.body2regular}
  }

  & .actions {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  & .balance {
    color: ${({ theme }) => theme.blackLightColor};
    ${typography.caption1bold}
    text-align: center;
  }
`;
